import React, { FC } from "react";
import { ImagesProps } from "./ContentScreen";
import SectionTitle from "./SectionTitle";
import ToolkitCard from "./ToolkitCard";

interface ToolkitProps {
  images: ImagesProps[];
}
const Toolkit: FC<ToolkitProps> = ({ images }) => {
  return (
    <div
      id="toolkit"
      className="w-full md:min-h-screen flex flex-col items-center md:items-start justify-center px-4 md:px-20 py-20"
    >
      <SectionTitle highlight="Check out" section="My Toolkit" />
      <div className="w-full grid  place-items-center px-0 md:px-20 lg:px-40 my-10 2xl:grid-cols-6 xl:grid-cols-5 lg:grid-cols-4 grid-cols-3 ">
        {images.map((skill, index) => (
          <ToolkitCard key={index} skill={skill} />
        ))}
      </div>
    </div>
  );
};

export default Toolkit;
